import Tooltip, { TooltipProps, tooltipClasses } from '@mui/material/Tooltip';
import { styled } from '@mui/material/styles';

function AppButton({ children, variantClass, ...rest }) {
  return rest.tooltipText || rest.title ? (
    <LightTooltip title={rest.tooltipText || rest.title} className="__themes_tip__tool">
      <button type="button" className={variantClass} {...rest}>
        <>{children}</>
      </button>
    </LightTooltip>
  ) : (
    <button type="button" className={variantClass} {...rest}>
      <>{children}</>
    </button>
  );
}

const LightTooltip = styled(({ className, ...props }) => (
  <Tooltip {...props} classes={{ popper: className }} />
))(({ theme }) => ({
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: '#7e1f8c',
    color: '#fff',
    boxShadow: theme.shadows[1],
    fontSize: 11,
  },
}));
export { LightTooltip };
export default AppButton;
